<div
  fxLayout="row"
  fxLayoutAlign="start center"
  class="clickable-row"
  (click)="toggleSelection(mail)">
  <mat-checkbox
    [checked]="mail.assigned"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
    (keydown.space)="$event.stopPropagation()"
    (change)="onCheckboxChange($event, mail)">
  </mat-checkbox>

  <div class="info" fxFlex fxLayout="column" style="margin-left: 16px">
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex>
      <img
        class="avatar mr-0"
        src="/assets/images/rooms/{{ getChannelIcon(mail.channelId) }}"
        alt="sala" />
      <span class="text-truncate detail">{{ mail.roomName }}</span>
      <mat-icon
        class="mat-icon-min"
        *ngIf="mail.assignedAnotherFlow"
        id="tooltip"
        [matTooltip]="
          ('ADMINISTRATION.CONVERSATION_FLOWS.INFO' | translate) +
          ' ' +
          getFlowNames(mail.otherAssignedFlows)
        "
        matTooltipPosition="above"
        (click)="$event.stopPropagation()"
        (keydown)="
          $event.key === 'Enter' || $event.key === ' '
            ? $event.stopPropagation()
            : null
        "
        tabindex="0"
        >info
      </mat-icon>
    </div>
  </div>
</div>
